export interface ICancelDirectDebitRequest {
    merchantNumber: string;
    acq: number;
    cardIndex: number;
    futureTransInd: CHBEventId;
    postingDate: string;
}

export interface ICancelDirectDebitResponse {
    caseId: number;
}
export interface IIsClaimExistsResult {
    returnCode: number;
    cbkId: number | null;
}
export interface ICheckCBKRequest {
    MerchantNumber: string;
}
export enum CHBEventId {
    DenyDeal = 1,
    CancelDirectDebitWithFutureTRX = 2,
    CancelDirectDebit = 3
}
